<template>
  <div
    id="select-airport"
  >
    <div class="col-heading">
      <h3 class="mb-4">
        Airport
      </h3>
    </div>
    <div class="form-check form-radio-inline">
      <label
        v-if="!hideAllOption"
      >
        <input
          id="all"
          v-model="selectedAirportId"
          class="form-check-input"
          type="radio"
          name="all"
          value="0"
          checked
        >
        <div
          class="radio-label"
        >
          <b>All</b>
        </div>
      </label>
      <label
        v-for="(airport, index) in airports"
        :key="index"
      >
        <input
          :id="airport.name"
          v-model="selectedAirportId"
          :disabled="disabled"
          :value="airport.id"
          :name="airport.name"
          class="form-check-input"
          type="radio"
        >
        <div
          :for="airport.name"
          class="radio-label"
        >
          <b>{{ airport.code }}</b>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
    name: 'SelectAirport',
    props: {
        hideAllOption: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            airports: state => state.airport.airports
        }),
        ...mapGetters({
            languageCode: 'getSelectedAirportLanguageCode'
        }),
        selectedAirportId: {
            get () {
                return this.$store.state.airport.selectedAirportId
            },
            async set (value) {
                await this.$store.dispatch('setSelectedAirportId', parseInt(value))
            }
        }
    },
    watch: {
        languageCode(newVal) {
            if (newVal !== null) {
                return moment.locale(newVal.toLowerCase())
            }
            return moment.locale('en-gb')
        }
    }
}
</script>
